import React from "react";
import {
  ContentsHeader,
  PrimaryButton,
  SecondaryButton,
} from "@graffer-inc/console-design-kit";

interface NewContentsHeaderProps {
  onSave: () => void;
  onCancel: () => void;
}

export const NewContentsHeader: React.FC<NewContentsHeaderProps> = ({
  onSave,
  onCancel,
}) => {
  return (
    <ContentsHeader
      title="申請振り分け設定作成"
      border={false}
      buttons={[
        [
          <div key="cancelButton" className="level-item">
            <SecondaryButton text="キャンセル" onClick={onCancel} />
          </div>,
          <div key="saveButton" className="level-item">
            <PrimaryButton text="登録" onClick={onSave} />
          </div>,
        ],
      ]}
    />
  );
};
